export const MAX_RESERVED = 1;
export const MAX_PROGRESS = 3;

export const TAGS_FOR_DESCRIPTION = [
  'instr_not_ok',
  'instr_not_ok_crucial',
];
